import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import { OAuthService, OAuthEvent } from 'angular-oauth2-oidc';
@Injectable()
export class SessionInterceptor implements HttpInterceptor {



    constructor( private store: Store<any> ,
    	private router: Router,
      private oauthService: OAuthService
    	) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      console.log('SessionInterceptor#intercept called', request.url);
      if (request.url.indexOf('token') === -1 ) {
        request = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + this.oauthService.getAccessToken())
                //request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'))
            });

        }
        return next.handle(request).pipe( tap(() => {},
      (err: any) => {

      if (err instanceof HttpErrorResponse) {
        if (err.status !== 401) {
         return;
        }
        //this.router.navigate(['login']);
      }
    }));
    }
}
